<template>
    <v-card color="kbWhite">
        <v-card-title class="text-h6">
            <span class="pt-2 kbDarkBlueText--text">{{$t('general.epayCoCredentials')}}</span>
        </v-card-title>

        <v-card-text>
            <v-form v-model="valid" ref="epaycoForm" lazy-validation>
                <v-row>
                    <v-col cols="12">
                        <v-text-field :label="$t('general.publicKey')"
                                      color="kbDarkBlueText"
                                      v-model="publicKey"
                                      :rules="[rules.required]">
                        </v-text-field>
                    </v-col>

                    <v-col cols="12">
                        <v-text-field :label="$t('general.privateKey')"
                                      color="kbDarkBlueText"
                                      v-model="privateKey"
                                      :rules="[rules.required]">
                        </v-text-field>
                    </v-col>

                    <v-col cols="12">
                        <v-switch color="kbLightBlue"
                                  :label="$t('general.testEnvironment')"
                                  v-model="epaycoTest"></v-switch>
                    </v-col>
                </v-row>
            </v-form>
        </v-card-text>

        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="kbLightBlue"
                   dark
                   @click="submit()">{{$t('general.update')}}</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import { mapState } from 'vuex'
import notifications from '@/libs/notifications'
import rules from '@/libs/rules'
export default {
  created () {
    const extradata = this.selectedApp.extra_data

    const epaycoPublicKeyExtradata = extradata.find(extradata => {
      return extradata.field === 'EPAYCOPUBLICKEY'
    })

    const epaycoPrivateKeyExtradata = extradata.find(extradata => {
      return extradata.field === 'EPAYCOPRIVATEKEY'
    })

    const epaycoTestExtradata = extradata.find(extradata => {
      return extradata.field === 'EPAYCOTEST'
    })

    if (epaycoPublicKeyExtradata) this.publicKey = epaycoPublicKeyExtradata.value
    if (epaycoPrivateKeyExtradata) this.privateKey = epaycoPrivateKeyExtradata.value
    if (epaycoTestExtradata) this.epaycoTest = epaycoTestExtradata.value === 'true'
  },
  data () {
    return {
      publicKey: '',
      privateKey: '',
      epaycoTest: false,
      rules,
      valid: false
    }
  },
  computed: {
    ...mapState({
      selectedApp: state => state.apps.selectedApp
    })
  },
  methods: {
    submit () {
      if (!this.$refs.epaycoForm.validate()) return

      const extradata = [
        {
          access: 'private',
          field: 'EPAYCOPUBLICKEY',
          value: this.publicKey
        },
        {
          access: 'private',
          field: 'EPAYCOPRIVATEKEY',
          value: this.privateKey
        },
        {
          access: 'private',
          field: 'EPAYCOTEST',
          value: this.epaycoTest
        }
      ]

      const companyId = this.$store.getters.companyUuid
      const appId = this.$store.getters.appUuid
      const data = { extradata: extradata }
      this.$store.dispatch('updateApp', { companyId, appId, data }).then(() => {
        this.updatingApp = false
        notifications.success(this.$t('general.applicationSuccessfullyUpdated'))
      }).catch(error => {
        this.updatingApp = false
        notifications.error(error.message)
      })
    }
  }
}
</script>
